export default __webpack_public_path__ + "static/media/doc-file.500c71d4.svg";